import { Table } from "semantic-ui-react";
import dateTimeUtils from "../../../../utils/dateTimeUtils";
import { UserEllipsisPopupButton } from "../../../../components/people";
import UserInfoCell from "../../../../components/userInfoCell/UserInfoCell";
import { Title } from "../../../../components/listViewTemplates";
import { type AddPeopleToContentTypes } from "../../../../enums";
import RestrictedByTooltip from "../../../../components/restrictedByTooltip/RestrictedByTooltip";
import { Typography } from "../../../../components/common/Typography/Typography";
import EnvelopeBan from "../../../../images/envelope-ban.svg?react";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { FeatureFlags } from "../../../../featureFlags";

interface UserListRowProps {
  user: any;
  onDeleteUser: (id: number) => void;
  onAddToGroup: (id: number) => void;
  onAddToRole: (id: number) => void;
  onAddToBlackList: (ids: number[]) => void;
  onRemoveFromBlackList: (ids: number[]) => void;
  onAddToContent: (id: number, contentType: AddPeopleToContentTypes) => void;
  goToEditUser: (id: number) => void;
  isEllipsisMenuDisabled: boolean;
  hasPermission?: boolean;
}

export function UserListRow(props: UserListRowProps) {
  const blackListEnabled = useFeatureFlag(FeatureFlags.BlackList);
  const { user, isEllipsisMenuDisabled, hasPermission = true } = props;

  const buttonHandlers = {
    goToEditUser: props.goToEditUser,
    onDeleteUser: props.onDeleteUser,
    onAddToGroup: props.onAddToGroup,
    onAddToRole: props.onAddToRole,
    onAddToBlackList: props.onAddToBlackList,
    onRemoveFromBlackList: props.onRemoveFromBlackList,
    onAddToContent: props.onAddToContent,
  };

  const blacklistedStatusCellContent = user.isBlackList ? (
    <div className="userListRowBlacklisted">
      <EnvelopeBan />
      <Typography variant="title2">No Contact</Typography>
    </div>
  ) : (
    "-"
  );

  return (
    <>
      <Table.Cell width={3}>
        <UserInfoCell user={user} deepLink goToEditUser={buttonHandlers.goToEditUser} />
      </Table.Cell>
      <Table.Cell width={2}>
        <Title title={user.department} />
      </Table.Cell>
      <Table.Cell width={2}>
        <Title title={user.title} />
      </Table.Cell>
      {blackListEnabled && <Table.Cell width={3}>{blacklistedStatusCellContent}</Table.Cell>}
      <Table.Cell width={3}>{dateTimeUtils.formatDate(user.createDate)}</Table.Cell>
      <Table.Cell width={3}>{dateTimeUtils.formatEmptyDate(user.lastLoginDate)}</Table.Cell>
      <Table.Cell className="align-right" width={2}>
        <RestrictedByTooltip hasPermission={hasPermission}>
          <UserEllipsisPopupButton disabled={isEllipsisMenuDisabled} user={user} {...buttonHandlers} />
        </RestrictedByTooltip>
      </Table.Cell>
    </>
  );
}
